import Datetime from "react-datetime";
import moment from "moment";

const DateFilterTable = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  selectedDateType,
  setSelectedDateType,
  handleSearch,
}) => {
  return (
    <>
      <div className="d-flex justify-content-center" style={{ width: "150px" }}>
        <select
          className="form-select"
          aria-label="Default select example"
          value={selectedDateType}
          onChange={(e) => setSelectedDateType(e.target.value)}
          style={{ maxWidth: "150px" }}
        >
          <option value="1">วันที่เอกสาร</option>
          <option value="2">
            {window.location.pathname === "/purchase-order"
              ? "วันที่จัดส่ง"
              : window.location.pathname === "/product-receipt"
              ? "วันที่รับ"
              : window.location.pathname === "/payment-voucher"
              ? "วันที่ชำระ"
              : "วันที่สร้าง"}
          </option>
        </select>
      </div>
      <div className=" d-flex align-items-center">
        <label className="text-black text-center" style={{ width: "40px" }}>
          วันที่
        </label>
        <Datetime
          className="input-spacing-input-date"
          value={startDate || null}
          dateFormat="DD-MM-YYYY"
          timeFormat={false}
          onChange={(date) => {
            setStartDate(moment(date).format("DD-MM-YYYY"));
          }}
          renderInput={(props, openCalendar, closeCalendar) => (
            <input {...props} style={{ width: "110px" }} />
          )}
        />
      </div>
      <div
        className=" d-flex align-items-center"
        style={{ marginLeft: "-44px" }}
      >
        <label className="text-black text-center" style={{ width: "40px" }}>
          ถึง
        </label>
        <Datetime
          className="input-spacing-input-date"
          value={endDate || null}
          dateFormat="DD-MM-YYYY"
          timeFormat={false}
          onChange={(date) => {
            setEndDate(moment(date).format("DD-MM-YYYY"));
          }}
          renderInput={(props, openCalendar, closeCalendar) => (
            <input {...props} style={{ width: "110px" }} />
          )}
        />
        <button
          className="btn btn-outline-secondary"
          type="button"
          aria-label="Search"
          onClick={handleSearch}
          style={{ marginLeft: "-48px" }}
        >
          <i className="fas fa-search" />
        </button>
      </div>
    </>
  );
};

export default DateFilterTable;
